import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, HostListener } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-pie-grid',
  imports: [
    CommonModule,
    NgxChartsModule,
  ],
  templateUrl: './pie-grid.component.html',
  styleUrl: './pie-grid.component.scss'
})
export class PieGridComponent implements OnInit {

  @Input() modelWiseScores: any[] = [];

  modelWiseScoresData: any[] = [];
  view: [number, number] = [600, 500];

  // options
  // showLegend: boolean = true;
  // showLabels: boolean = true;

  constructor() {
    Object.assign(this.modelWiseScores);
  }

  ngOnInit(): void {
    if (this.modelWiseScores.length) {
      this.modelWiseScoresData = this.modelWiseScores;
    }

    this.updateViewForViewport();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateViewForViewport();
  }

  private updateViewForViewport(): void {
    if (typeof window === 'undefined') return;
    const w = window.innerWidth;
    if (w <= 360) {
      this.view = [150, 150] as [number, number];
    } else if (w <= 480) {
      this.view = [280, 250] as [number, number];
    } else if (w <= 768) {
      this.view = [400, 320] as [number, number];
    } else {
      this.view = [600, 500] as [number, number];
    }
  }

  onSelect(event: any) {
    // // console.log(event);
  }
}
